import Stack from "@mui/material/Stack";

import { useAuth } from "../../../../providers/AuthProvider";
import { CRMAppLocationIdentifier, FaqProps } from "../../../../types/Faq";
import DossierCategoryTotalRow from "../DossierCategoryTotalRow";

const DossierBudgetTotals = ({
  dossierId,
  fuel,
  servicing,
  tyres,
  insurance,
  rego,
  faqs,
  faqAppLocationIdentifiers,
}: {
  dossierId: string;
  fuel: number | undefined;
  servicing: number | undefined;
  tyres: number | undefined;
  insurance: number | undefined;
  rego: number | undefined;
  faqs: FaqProps;
  faqAppLocationIdentifiers: {
    category: CRMAppLocationIdentifier;
    availableBudget: CRMAppLocationIdentifier;
  };
}) => {
  const { getScopedPageUrl } = useAuth();
  const totalBudget =
    fuel !== undefined &&
    servicing !== undefined &&
    tyres !== undefined &&
    insurance !== undefined &&
    rego !== undefined
      ? fuel + servicing + tyres + insurance + rego
      : undefined;

  const renderBudgetRow = (
    label: string,
    value: number | undefined,
    targetUrl?: string,
    isTotal: boolean = false
  ) => {
    return (
      <DossierCategoryTotalRow
        label={label}
        values={value ? [value] : [0]}
        isTotal={isTotal}
        faqs={faqs}
        faqAppLocationIdentifier={
          isTotal
            ? faqAppLocationIdentifiers.availableBudget
            : faqAppLocationIdentifiers.category
        }
        targetUrls={
          targetUrl ? [`${targetUrl}?includes=invoiced,spent`] : undefined
        }
      />
    );
  };

  return (
    <Stack spacing={1}>
      {renderBudgetRow(
        "Fuel / Charging",
        fuel,
        getScopedPageUrl("dossierBudget", dossierId, "fuel")
      )}
      {renderBudgetRow(
        "Service",
        servicing,
        getScopedPageUrl("dossierBudget", dossierId, "servicing")
      )}
      {renderBudgetRow(
        "Tyres",
        tyres,
        getScopedPageUrl("dossierBudget", dossierId, "tyres")
      )}
      {renderBudgetRow(
        "Insurance",
        insurance,
        getScopedPageUrl("dossierBudget", dossierId, "insurance")
      )}
      {renderBudgetRow(
        "Rego / CTP",
        rego,
        getScopedPageUrl("dossierBudget", dossierId, "rego")
      )}
      {renderBudgetRow(
        "Available Budget",
        totalBudget,
        getScopedPageUrl("dossierTransactions", dossierId),
        true
      )}
    </Stack>
  );
};

export default DossierBudgetTotals;
